import { key } from 'core-ts-types';
import { ICrossCourseCorequisite } from '../../../interfaces/scheduler_interfaces';
import { IRawSection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export interface ICrossCourseCorequisites {
  id: key;
  course_corequisites: ICrossCourseCorequisite[];
}

export class CrossCourseCorequisites {
  static build(crossCourseCorequisites: Partial<CrossCourseCorequisites>): CrossCourseCorequisites {
    return new CrossCourseCorequisites(crossCourseCorequisites);
  }
  id: key;
  course_corequisites: ICrossCourseCorequisite[];

  constructor(crossCourseCorequisites: Partial<CrossCourseCorequisites>) {
    _4.merge(this, crossCourseCorequisites);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_corequisite/builders/cross_course_corequisite_builder.ts